import ViewListIcon from "@material-ui/icons/ViewList";

import { InventoryList } from "./List/List";

export const inventoryListResource = {
	icon: ViewListIcon,
	list: InventoryList,
};
